<template>
    <hts-form-button
        icon-name="hi-cloud-arrow-up-icon"
        :loading="uploading"
        @click="open">
        Upload
    </hts-form-button>
</template>

<script setup>
const props = defineProps({
  label: {
    type: String,
    default: () => $t('labels.upload')
  },
  api: {
    type: Object,
    required: true
  },
  successLabel: {
    type: String,
    default: ''
  },
  uriParams: Object
})

const { api, successLabel, uriParams } = toRefs(props)

const input = ref(null)
const uploading = ref(false)
const emits = defineEmits(['change', 'upload-success', 'upload-fail'])

const open = () => {
  if (input?.value) {
    input.value.remove()
  }
  input.value = document.createElement('input')
  input.value.type = 'file'
  input.value.addEventListener('change', fileChange)
  input.value.click()
}

const file = ref(null)
const fileChange = (e) => {
  if (e.target.files.length) {
    file.value = e.target.files[0]
  }
  upload()
  input.value.remove()
  input.value = null
}

const upload = async () => {
  if (uploading.value) {
    return
  }

  if (!file.value) {
    process.client && $toast().error('Không lấy được file đã chọn')
    return
  }
  const data = new FormData()
  try {
    data.append('file', file.value)
  } catch (e) {
    process.client && $toast().error('Không lấy được file đã chọn')
    return
  }
  uploading.value = true

  const res = await $api(api.value, { uriParams: uriParams.value, body: data })
  const resData = $lodash.get(res, 'data.value')

  if (resData?.success) {
    successLabel.value && process.client && $toast().success(successLabel.value)
    emits('upload-success', resData.data)
    uploading.value = false
  } else {
    uploading.value = false
  }
}

defineExpose({
  open
})
</script>
